import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import {ScriptPlayer} from './player.script.js';

import pick from '../pick.mp3';

function gameobjectplayer() {

    const player = new HYPERCUBEJS.Node('player');
    const meshplayer = new HYPERCUBEJS.MeshBox('meshplayer', [0.5, 0.5, 0.5]);
    const materialmeshplayer = new HYPERCUBEJS.MaterialColor('materialmeshplayer', {'color': [0, 0, 0]});

    meshplayer.setmaterial(materialmeshplayer);
    // meshplayer.setshadowcasting(false);
    player.addmesh(meshplayer);
    player.setscript(new ScriptPlayer());
    player.setaudio(new Audio(pick));

    player.setcomponent('collideraabb', {

        'type': 'dynamic',

        'min': [-0.2, -0.25, -0.2],
        'max': [0.2, 0.25, 0.2]
    });

    return player;
}

export {

    gameobjectplayer
};

export default gameobjectplayer;
